export const SECTION_PERSONAL_DETAILS = 1;
export const SECTION_DRIVING_LICENSE = 2;
export const SECTION_OTHER_INFORMATION = 3;
export const SECTION_CONTACT_DETAILS = 4;
export const SECTION_HOUSEHOLD = 5;
export const SECTION_EMPLOYMENT = 6;
export const SECTION_CONFIRMATION = 7;
